import ProjectUtils from "../../../../../../utils/project-utils.js";

export function makeMainDispatchItems(data) {
    const mainDispatch = data?.dispatch?.mainDispatch ?? {};

    return [
        {
            label: "D/H inicial",
            value: ProjectUtils.formatDate(mainDispatch?.dispatch_start ?? "", null, true),
        },
        {
            label: "D/H final",
            value: mainDispatch?.dispatch_end ?? "",
        },
        {
            label: "Guarnição",
            value: mainDispatch?.garrison_name ?? "",
        },
        {
            label: "Contingentes",
            value: mainDispatch?.contingent_namewar ?? "",
        },
    ];
}

export function makeNumbercheckbook(data) {
    const mainDispatch = data?.dispatch?.mainDispatch ?? {};

    return [
        {
            label: "Talão",
            value: mainDispatch?.dispatch_numbercheckbook ?? "",
        },
    ];
}